export default "__VITE_ASSET__BlXAc4xm__"